import * as React from "react";
const SvgFiRrPractice = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-practice_svg__a)">
      <path
        fill="#062147"
        d="M14.5 12.5a2.5 2.5 0 1 1-5 .001 2.5 2.5 0 0 1 5 0m7.181-1.073-2.604 3.721a2 2 0 0 1-1.638.853H6.562a2 2 0 0 1-1.638-.853l-2.604-3.72a1.001 1.001 0 0 0-1.639 1.146l2.604 3.721a4 4 0 0 0 3.277 1.706H8v5a1 1 0 1 0 2 0v-5h4v5a1 1 0 1 0 2 0v-5h1.438a4 4 0 0 0 3.277-1.706l2.604-3.72a1 1 0 0 0-1.638-1.148M9.001 5h2v.95c0 .515.622.773.987.408l1.767-1.767a.836.836 0 0 0 0-1.183l-1.767-1.767a.579.579 0 0 0-.988.41v.948H9A1 1 0 1 0 9 5M.09 2.69A3.5 3.5 0 0 1 2.67.094c1.092-.249 2.16-.01 3.01.666a3.488 3.488 0 0 1 .05 5.425c-.464.382-.73.902-.73 1.43v.385a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-.386c0-.528-.264-1.047-.723-1.424C.233 5.332-.209 4.023.091 2.69m2.455 1.954c.393.322.715.703.955 1.122.24-.418.562-.8.955-1.124.346-.285.544-.7.544-1.143 0-.459-.207-.888-.567-1.175a1.46 1.46 0 0 0-.929-.326q-.19 0-.388.046a1.48 1.48 0 0 0-1.073 1.084c-.133.591.05 1.143.503 1.516m20.831 2.14a1 1 0 0 1-1.369.354l-.137-.08a3.5 3.5 0 0 1-1.372.778V8a1 1 0 1 1-2 0v-.163a3.5 3.5 0 0 1-1.372-.779l-.137.081a.998.998 0 1 1-1.014-1.724l.134-.079a3.5 3.5 0 0 1-.112-.835c0-.289.045-.566.112-.835l-.134-.079a1 1 0 0 1 1.014-1.724l.137.081a3.5 3.5 0 0 1 1.372-.779v-.163a1 1 0 1 1 2 0v.163c.517.156.985.42 1.372.78l.137-.082a1 1 0 0 1 1.014 1.724l-.134.08c.066.268.112.545.112.834 0 .29-.045.566-.112.835l.134.08a1 1 0 0 1 .355 1.368M21 4.5c0-.827-.673-1.5-1.5-1.5S18 3.673 18 4.5 18.673 6 19.5 6 21 5.327 21 4.5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-practice_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPractice;
